"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePTTInfiniteQuery = void 0;

var _reactQuery = require("react-query");

var _utils = require("../utils/utils");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Wrapper around react-query's useInfiniteQuery for "load more" pagination pattern
 * @deprecated - use react-query useInfiniteQuery() instead.
 */
var usePTTInfiniteQuery = function usePTTInfiniteQuery(_ref) {
  var _query$data$pages$red, _query$data, _query$data$pages, _query$data$pages$, _query$data2, _query$data2$pages;

  var baseUrl = _ref.baseUrl,
      queryName = _ref.queryName,
      queryKeys = _ref.queryKeys,
      offsetParamName = _ref.offsetParamName,
      pageDataField = _ref.pageDataField,
      getNextPageParam = _ref.getNextPageParam,
      queryOptions = _ref.queryOptions,
      fetchOptions = _ref.fetchOptions;
  var queryClient = (0, _reactQuery.useQueryClient)(); // The function called for fetching data

  var fetchFunction = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (_ref2) {
      var _ref2$pageParam = _ref2.pageParam,
          offsetParam = _ref2$pageParam === void 0 ? 0 : _ref2$pageParam;
      var url = new URL(baseUrl, window.location.href);
      url.searchParams.set(offsetParamName, offsetParam.toString());
      var response = yield (0, _utils.pttFetch)(url.toString(), fetchOptions);
      return response.data;
    });

    return function fetchFunction(_x) {
      return _ref3.apply(this, arguments);
    };
  }(); // Type meaning "at least a field named "value of pageDataField""


  var query = (0, _reactQuery.useInfiniteQuery)((0, _utils.getQueryKey)(queryName, queryKeys), fetchFunction, _objectSpread({
    getNextPageParam: getNextPageParam,
    // When the query key changes (new search text for example), we want to still show the latest data while fetching
    keepPreviousData: true
  }, queryOptions)); // aggregating all the pages in one array (allData)

  var allData = (_query$data$pages$red = (_query$data = query.data) === null || _query$data === void 0 ? void 0 : (_query$data$pages = _query$data.pages) === null || _query$data$pages === void 0 ? void 0 : _query$data$pages.reduce(function (agg, p) {
    return [].concat(_toConsumableArray(agg), _toConsumableArray(p[pageDataField]));
  }, [])) !== null && _query$data$pages$red !== void 0 ? _query$data$pages$red : []; // Looking at the first page for metadata (total etc...)
  // Keeping everything except the data

  var _ref4 = (_query$data$pages$ = (_query$data2 = query.data) === null || _query$data2 === void 0 ? void 0 : (_query$data2$pages = _query$data2.pages) === null || _query$data2$pages === void 0 ? void 0 : _query$data2$pages[0]) !== null && _query$data$pages$ !== void 0 ? _query$data$pages$ : {},
      _discard = _ref4[pageDataField],
      metadata = _objectWithoutProperties(_ref4, [pageDataField].map(_toPropertyKey));

  return _objectSpread(_objectSpread({}, query), {}, {
    // Because of keepPreviousData above, isLoading would remain false when searching/sorting
    isLoading: query.isLoading || query.isPreviousData,
    allData: allData,
    metadata: metadata,
    invalidate: function invalidate() {
      return queryClient.invalidateQueries(queryName);
    }
  });
};

exports.usePTTInfiniteQuery = usePTTInfiniteQuery;